<div [formGroup]="this.formGroup" class="mt-{{FIELD_SPACING}}">
  <div *ngIf="this.label != null" class="row">
    <div class="col-md-9">
      <div class="form-label">{{this.label}}
        <span *ngIf="this.isOptional" class="optional-tag">&nbsp;(optional)</span>
        <span *ngIf="this.tooltip != null" class="mt-1">
          <app-help-tooltip id="{{this.propertyId+'Tooltip'}}" [tooltipMessage]="this.tooltip"></app-help-tooltip>
        </span> 
      </div>
    </div>
    <div *ngIf="this.subText != null" class="col-md-12">
      <div [innerHTML]="this.subText"></div>
    </div>
  </div>
  <div class="row mt-{{LABEL_SPACING}} custom-calendar">
    <div class="col input-group">
      <input 
        onkeydown="return false"
        id="{{this.propertyId}}" 
        type="text" 
        class="form-control input-box"
        [ngClass]="(this.isInvalid()) ? 'is-invalid' : ''"
        formControlName="{{this.propertyName}}" 
        maxlength={{this.maxLength}} 
        placeholder="YYYY-MM-DD" 
        bsDatepicker
        [bsConfig]="{ showWeekNumbers:false, dateInputFormat: 'YYYY-MM-DD' }"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [isOpen]="isOpen"
        (bsValueChange)="this.emptyDateInput($event)">
      <div class="input-group-append">
        <button 
          class="btn custom-bg" 
          type="button" 
          (click)="isOpen = !isOpen"><i class="far fa-calendar-o"></i></button>
      </div>
    </div>
  </div>
  <app-validator-message [formGroup]="this.formGroup" propertyName="{{this.propertyName}}"></app-validator-message>
</div>